(function () {
  // Attribute qualifier is required: Shopify's own OS 2.0 wrapper for this
  // section reuses the exact same class as a substring ("shopify-section
  // shopify-section--main-customers-account"), and querySelector returns
  // the first match in document order — that outer wrapper, not this file's
  // own inner <section> that actually carries data-api-ready/data-section-id.
  // Without this qualifier, root silently resolves to the wrong element and
  // every data-* read below returns undefined.
  var root = document.querySelector('.shopify-section--main-customers-account[data-api-ready]');
  if (!root) return;

  var RETURN_EXCHANGE_URL = 'https://returns.logisy.tech/returns?encipherencode=gAAAAABpqQw0TqVDwp44gc11JurQsjSE_f1esKs6UM_vnnsfkByd9xB2WPwU_yeOewwBmZuGjkxdbhwOhnpQwflq02mGQUZ46g==';
  var RETURN_WINDOW_DAYS = 15;

  var loadingView = root.querySelector('[data-orders-loading]');
  var errorView   = root.querySelector('[data-orders-error]');
  var errorMsg    = root.querySelector('[data-orders-error-message]');
  var listView    = root.querySelector('[data-orders-list-view]');
  var detailView  = root.querySelector('[data-orders-detail-view]');
  var grid        = root.querySelector('[data-order-grid]');
  var tableBody   = root.querySelector('[data-order-table-body]');

  var noOrdersText = root.dataset.noOrdersText;

  var apiReady    = root.dataset.apiReady === 'true';
  var apiBaseUrl  = root.dataset.apiBaseUrl;
  var apiTimestamp = root.dataset.apiTimestamp;
  var apiSignature = root.dataset.apiSignature;
  var customerId  = root.dataset.customerId;

  var ordersById  = {};
  var statusNodesById = {};
  var openDetailOrderId = null;

  function headerOffset() {
    return window.innerWidth >= 768 ? 100 : 93;
  }

  function scrollSectionToTop(smooth) {
    var targetY = root.getBoundingClientRect().top + window.pageYOffset - headerOffset();
    window.scrollTo({ top: Math.max(targetY, 0), behavior: smooth ? 'smooth' : 'auto' });
  }

  function showState(state) {
    loadingView.hidden = state !== 'loading';
    errorView.hidden   = state !== 'error';
    listView.hidden    = state !== 'list';
    detailView.hidden  = state !== 'detail';
    root.classList.toggle('is-detail-view', state === 'detail');
  }

  function showError(message) {
    errorMsg.textContent = message;
    showState('error');
  }

  function getOrderIdFromUrl() {
    return new URLSearchParams(window.location.search).get('order');
  }

  function setOrderInUrl(orderId, push) {
    var url = new URL(window.location.href);
    if (orderId) url.searchParams.set('order', orderId);
    else url.searchParams.delete('order');
    history[push ? 'pushState' : 'replaceState']({}, '', url.toString());
  }

  function syncDetailFromUrl() {
    var id = getOrderIdFromUrl();
    if (id && ordersById[String(id)]) {
      openDetail(id);
    }
  }

  function formatMoney(priceStr) {
    var n = parseFloat(priceStr || '0');
    return '₹' + Math.round(n).toLocaleString('en-IN');
  }

  function formatDate(epochSeconds) {
    if (!epochSeconds) return '';
    var d = new Date(epochSeconds * 1000);
    return d.toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' });
  }

  function formatDateTime(epochSeconds) {
    if (!epochSeconds) return '';
    var d = new Date(epochSeconds * 1000);
    var date = d.toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' });
    var time = d.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit' }).replace(' ', '').toLowerCase();
    return date + ' at ' + time;
  }

  // Return/Exchange requires actual delivery confirmation and stays within the return window.
  function canReturn(order) {
    if (order.cancelled_at || order.financial_status === 'voided') return false;
    if (order.delivery_status !== 'DELIVERED') return false;
    if (!order.delivered_at) return true;
    var daysSinceDelivery = (Date.now() / 1000 - order.delivered_at) / 86400;
    return daysSinceDelivery <= RETURN_WINDOW_DAYS;
  }

  function returnLinkHtml(order, opts) {
    if (canReturn(order)) {
      return '<a class="' + opts.linkClass + ' hover-slide-up-offset" href="' + escapeHtml(RETURN_EXCHANGE_URL) + '" target="_blank" rel="noopener">' + opts.linkText + '</a>';
    }
    return '<span class="' + opts.disabledClass + '">' + opts.disabledText + '</span>';
  }

  // order.delivery_status is patched in later by fetchDeliveryStatuses() —
  // Shopify's Fulfillment.displayStatus enum, rendered in sentence case.
  function statusInfo(order) {
    if (order.cancelled_at) {
      return { label: 'Cancelled', className: 'customers-order-status--cancelled' };
    }
    if (order.delivery_status) {
      const words = order.delivery_status.toLowerCase().split('_');
      const label = words[0].charAt(0).toUpperCase() + words[0].slice(1) + (words.length > 1 ? ' ' + words.slice(1).join(' ') : '');
      return { label: label, className: 'customers-delivery-status--' + order.delivery_status.toLowerCase().replace(/_/g, '-') };
    }
    if (order.fulfillment_status === 'fulfilled') {
      return { label: 'Fulfilled', className: 'customers-order-status--shipped' };
    }
    if (order.fulfillment_status === 'partial') {
      return { label: 'Processing', className: 'customers-order-status--processing' };
    }
    return { label: 'Order Placed', className: 'customers-order-status--placed' };
  }

  function humanize(str) {
    if (!str) return '';
    return str.split('_').map(function (w) {
      return w.charAt(0).toUpperCase() + w.slice(1);
    }).join(' ');
  }

  function escapeHtml(str) {
    var div = document.createElement('div');
    div.textContent = str == null ? '' : String(str);
    return div.innerHTML;
  }

  function renderOrderCard(order) {
    var status = statusInfo(order);
    var el = document.createElement('div');
    el.className = 'customers-order-card';
    el.innerHTML =
      '<p class="customers-order-card__name" data-order-detail-open data-order-id="' + order.id + '">Order ' + escapeHtml(order.name) + '</p>' +
      '<div class="customers-order-card__meta">' +
        '<div class="customers-order-card__field">' +
          '<span class="customers-order-card__label">Date</span>' +
          '<span class="customers-order-card__value">' + formatDate(order.created_at) + '</span>' +
        '</div>' +
        '<div class="customers-order-card__field">' +
          '<span class="customers-order-card__label">Fulfilment Status</span>' +
          '<span class="customers-order-card__value customers-order-card__value--secondary" data-order-status>' + status.label + '</span>' +
        '</div>' +
        '<div class="customers-order-card__field">' +
          '<span class="customers-order-card__label">Payment Status</span>' +
          '<span class="customers-order-card__value customers-order-card__value--secondary">' + humanize(order.financial_status) + '</span>' +
        '</div>' +
        '<div class="customers-order-card__field">' +
          '<span class="customers-order-card__label">Total</span>' +
          '<span class="customers-order-card__value customers-order-card__value--secondary">' + formatMoney(order.total_price) + '</span>' +
        '</div>' +
        '<div class="customers-order-card__field">' +
          '<span class="customers-order-card__label">Return / Exchange</span>' +
          '<span data-order-return>' + returnLinkHtml(order, {
            linkClass: 'customers-order-card__return-link',
            linkText: 'Return / Exchange',
            disabledClass: 'customers-order-card__value customers-order-card__value--muted',
            disabledText: 'Unavailable'
          }) + '</span>' +
        '</div>' +
      '</div>' +
      '<a href="#" class="customers-btn customers-btn--outline customers-btn--full" data-order-detail-open data-order-id="' + order.id + '">' +
        'View order details' +
      '</a>';
    return el;
  }

  function renderOrderRow(order) {
    var status = statusInfo(order);
    var tr = document.createElement('tr');
    tr.className = 'customers-order-table__row';
    tr.setAttribute('data-order-detail-open', '');
    tr.dataset.orderId = order.id;
    tr.innerHTML =
      '<td class="customers-order-table__cell--bold">' + escapeHtml(order.name) + '</td>' +
      '<td>' + formatDate(order.created_at) + '</td>' +
      '<td class="customers-order-table__cell--payment">' + humanize(order.financial_status) + '</td>' +
      '<td class="' + status.className + '" data-order-status>' + status.label + '</td>' +
      '<td class="customers-order-table__cell--total">' + formatMoney(order.total_price) + '</td>' +
      '<td data-order-return>' + returnLinkHtml(order, {
        linkClass: 'customers-return-link',
        linkText: 'Return / Exchange &gt;',
        disabledClass: 'customers-return-link customers-return-link--disabled',
        disabledText: 'Return / Exchange Unavailable'
      }) + '</td>';
    return tr;
  }

  function addOrders(orders) {
    orders.forEach(function (order) {
      ordersById[String(order.id)] = order;
      var card = renderOrderCard(order);
      var row = renderOrderRow(order);
      grid.appendChild(card);
      tableBody.appendChild(row);
      statusNodesById[String(order.id)] = {
        cardEl: card.querySelector('[data-order-status]'),
        rowEl: row.querySelector('[data-order-status]'),
        cardReturnEl: card.querySelector('[data-order-return]'),
        rowReturnEl: row.querySelector('[data-order-return]')
      };
    });
  }

  function renderTrackingBanner(order) {
    var banner = root.querySelector('[data-detail-banner]');
    var isCancelledOrVoided = !!order.cancelled_at || order.financial_status === 'voided';
    var fulfillment = order.latest_fulfillment;
    var tracking = !isCancelledOrVoided && fulfillment && (fulfillment.tracking_number || fulfillment.tracking_url);
    if (!tracking) {
      banner.hidden = true;
      return;
    }
    banner.hidden = false;
    var shipDate = formatDate(fulfillment.created_at);
    var trackingNumber = fulfillment.tracking_number;
    root.querySelector('[data-detail-banner-text]').textContent =
      'Your order has been sent' + (shipDate ? ' on ' + shipDate : '') +
      (trackingNumber ? '. Track the shipment with number ' + trackingNumber + '.' : '.');
    var trackLink = root.querySelector('[data-detail-tracking-link]');
    if (fulfillment.tracking_url) {
      trackLink.href = fulfillment.tracking_url;
    } else {
      trackLink.removeAttribute('href');
    }
  }

  function refreshOrderStatus(order) {
    var status = statusInfo(order);
    var nodes = statusNodesById[String(order.id)];
    if (nodes) {
      if (nodes.cardEl) { nodes.cardEl.textContent = status.label; }
      if (nodes.rowEl) { nodes.rowEl.textContent = status.label; nodes.rowEl.className = status.className; }
      if (nodes.cardReturnEl) {
        nodes.cardReturnEl.innerHTML = returnLinkHtml(order, {
          linkClass: 'customers-order-card__return-link',
          linkText: 'Return / Exchange',
          disabledClass: 'customers-order-card__value customers-order-card__value--muted',
          disabledText: 'Unavailable'
        });
      }
      if (nodes.rowReturnEl) {
        nodes.rowReturnEl.innerHTML = returnLinkHtml(order, {
          linkClass: 'customers-return-link',
          linkText: 'Return / Exchange &gt;',
          disabledClass: 'customers-return-link customers-return-link--disabled',
          disabledText: 'Return / Exchange Unavailable'
        });
      }
    }
    if (openDetailOrderId === String(order.id)) {
      var detailLabelEl = root.querySelector('[data-detail-status-label]');
      detailLabelEl.textContent = status.label;
      detailLabelEl.className = status.className;
      var detailReturnEl = root.querySelector('[data-detail-return]');
      if (detailReturnEl) {
        detailReturnEl.innerHTML = returnLinkHtml(order, {
          linkClass: 'customers-return-link',
          linkText: 'RETURN / EXCHANGE &gt;',
          disabledClass: 'customers-return-link customers-return-link--disabled',
          disabledText: 'Return / Exchange Unavailable'
        });
      }
      renderTrackingBanner(order);
    }
  }

  function openDetail(orderId) {
    var order = ordersById[String(orderId)];
    if (!order) return;

    openDetailOrderId = String(orderId);
    var status = statusInfo(order);

    root.querySelector('[data-detail-title]').textContent = 'Order ' + order.name;
    root.querySelector('[data-detail-subtitle]').textContent = formatDateTime(order.created_at);
    root.querySelector('[data-detail-status-name]').textContent = 'Order ' + order.name;
    root.querySelector('[data-detail-status-label]').textContent = status.label;
    root.querySelector('[data-detail-status-label]').className = status.className;

    var subtotalRow = root.querySelector('[data-detail-subtotal-row]');
    if (order.subtotal_price) {
      subtotalRow.hidden = false;
      root.querySelector('[data-detail-subtotal]').textContent = formatMoney(order.subtotal_price);
    } else {
      subtotalRow.hidden = true;
    }

    var shippingRow = root.querySelector('[data-detail-shipping-row]');
    var shippingLine = order.shipping_lines && order.shipping_lines[0];
    if (shippingLine) {
      shippingRow.hidden = false;
      var shippingPrice = parseFloat(shippingLine.price || '0');
      root.querySelector('[data-detail-shipping-label]').textContent =
        'Shipping' + (shippingPrice === 0 ? ' (Free Delivery)' : '');
      root.querySelector('[data-detail-shipping-price]').textContent = formatMoney(shippingLine.price);
    } else {
      shippingRow.hidden = true;
    }

    var taxRow = root.querySelector('[data-detail-tax-row]');
    var taxLine = order.tax_lines && order.tax_lines[0];
    if (taxLine) {
      taxRow.hidden = false;
      var taxLabel = (order.taxes_included ? 'Taxes included' : 'Taxes') +
        ' (' + taxLine.title + ' ' + (parseFloat(taxLine.rate || 0) * 100).toFixed(1) + '%)';
      root.querySelector('[data-detail-tax-label]').textContent = taxLabel;
      root.querySelector('[data-detail-tax-price]').textContent = formatMoney(taxLine.price);
    } else {
      taxRow.hidden = true;
    }

    var returnEl = root.querySelector('[data-detail-return]');
    returnEl.innerHTML = returnLinkHtml(order, {
      linkClass: 'customers-return-link',
      linkText: 'RETURN / EXCHANGE &gt;',
      disabledClass: 'customers-return-link customers-return-link--disabled',
      disabledText: 'Return / Exchange Unavailable'
    });

    renderTrackingBanner(order);

    function renderAddressCard(cardSelector, bodySelector, addr) {
      var card = root.querySelector(cardSelector);
      if (!addr || !(addr.name || addr.address1 || addr.city)) {
        card.hidden = true;
        return;
      }
      card.hidden = false;
      var lines = [
        addr.name,
        addr.address1,
        addr.address2,
        [addr.zip, addr.city, addr.province].filter(Boolean).join(' '),
        addr.country,
      ].filter(Boolean);
      root.querySelector(bodySelector).innerHTML = lines.map(escapeHtml).join('<br>');
    }

    renderAddressCard('[data-detail-billing-card]', '[data-detail-billing-address]', order.billing_address);
    renderAddressCard('[data-detail-shipping-card]', '[data-detail-shipping-address]', order.shipping_address);

    var productsEl = root.querySelector('[data-detail-products]');
    productsEl.innerHTML = '';
    (order.line_items || []).forEach(function (item) {
      var row = document.createElement('div');
      row.className = 'customers-order-detail__product';
      var imgSrc = item.image && item.image.src ? item.image.src : '';

      var variantParts = item.variant_title ? item.variant_title.split('/') : [];
      var sizeName  = variantParts[1] ? variantParts[1].trim() : '';
      var isValidCssColor = /^(#([0-9a-f]{3}|[0-9a-f]{6})|rgba?\([\d.,\s%]+\))$/i.test(item.color_hex || '');
      var swatchHex = isValidCssColor ? item.color_hex : null;

      var swatchSpan = swatchHex ? '<span class="customers-order-detail__product-swatch" style="background:' + swatchHex + ';"></span>' : '';
      var sizeTagSpan = sizeName ? '<span class="customers-order-detail__tag">SIZE : ' + escapeHtml(sizeName) + '</span>' : '';
      var qtySpan = '<div class="customers-order-detail__product-qty">QTY : ' + item.quantity + '</div>';
      var priceSpan = '<div class="customers-order-detail__product-total">' + formatMoney(item.price) + '</div>';

      row.innerHTML =
        '<div class="customers-order-detail__product-media">' +
          (imgSrc
            ? '<img src="' + escapeHtml(imgSrc) + '" alt="' + escapeHtml(item.title) + '" class="customers-order-detail__product-image" width="149" height="201">'
            : '<div class="customers-order-detail__product-image" style="background:#eee;"></div>') +
          '<div class="customers-order-detail__product-info">' +
            '<p class="customers-order-detail__product-name">' + escapeHtml(item.title) + '</p>' +
            (item.description ? '<p class="customers-order-detail__product-desc">' + escapeHtml(item.description) + '</p>' : '') +
            '<div class="customers-order-detail__mobile-only">' +
              '<div class="customers-order-detail__product-swatch-price">' +
                swatchSpan +
                priceSpan +
              '</div>' +
            '</div>' +
            '<div class="customers-order-detail__desktop-only">' +
              '<div class="customers-order-detail__product-tags-left">' +
                swatchSpan +
                sizeTagSpan +
              '</div>' +
            '</div>' +
            '<div class="customers-order-detail__mobile-only customers-order-detail__product-sizeqty-wrap">' +
              '<div class="customers-order-detail__product-sizeqty-row">' +
                sizeTagSpan +
                qtySpan +
              '</div>' +
            '</div>' +
          '</div>' +
        '</div>' +
        '<div class="customers-order-detail__desktop-only">' + qtySpan + '</div>' +
        '<div class="customers-order-detail__desktop-only">' + priceSpan + '</div>';
      productsEl.appendChild(row);
    });

    showState('detail');
    scrollSectionToTop(true);
  }

  root.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-order-detail-open]');
    if (opener) {
      var nestedLink = e.target.closest('a, button');
      // A nested link (e.g. Return/Exchange) should behave on its own, not open detail too.
      if (nestedLink && nestedLink !== opener) {
        return;
      }
      e.preventDefault();
      openDetail(opener.dataset.orderId);
      setOrderInUrl(opener.dataset.orderId, true);
      return;
    }
    if (e.target.closest('[data-order-detail-close]')) {
      showState('list');
      scrollSectionToTop(true);
      setOrderInUrl(null, true);
    }
  });

  window.addEventListener('popstate', function () {
    var id = getOrderIdFromUrl();
    if (id && ordersById[String(id)]) {
      openDetail(id);
    } else {
      showState('list');
    }
  });

  function renderOrders(orders) {
    if (!orders || orders.length === 0) {
      showError(noOrdersText);
      return;
    }
    addOrders(orders);
    showState('list');
    syncDetailFromUrl();
  }

  // Patches Fulfillment.displayStatus (replyall-middleware) into orders
  // already shown from fulfillment_status alone.
  function fetchDeliveryStatuses(orders) {
    if (!apiReady || !orders || !orders.length) return;
    fetch(apiBaseUrl + '/orders/delivery-status', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        customerId: customerId,
        timestamp: apiTimestamp,
        signature: apiSignature,
        orderIds: orders.map(function (o) { return o.id; })
      })
    })
      .then(function (res) { return res.ok ? res.json() : null; })
      .then(function (data) {
        if (!data || !data.statuses) return;
        orders.forEach(function (order) {
          var raw = data.statuses[String(order.id)];
          if (!raw) return;
          order.delivery_status = raw.status;
          order.delivered_at = raw.delivered_at ? Math.floor(new Date(raw.delivered_at).getTime() / 1000) : null;
          // Fills gaps in Liquid's native order.fulfillments, which is sometimes empty.
          if (raw.tracking_number || raw.tracking_url || raw.created_at) {
            var fulfillment = order.latest_fulfillment || {};
            fulfillment.tracking_number = raw.tracking_number || fulfillment.tracking_number || null;
            fulfillment.tracking_url = raw.tracking_url || fulfillment.tracking_url || null;
            if (raw.created_at) {
              fulfillment.created_at = Math.floor(new Date(raw.created_at).getTime() / 1000);
            }
            order.latest_fulfillment = fulfillment;
          }
          refreshOrderStatus(order);
        });
      })
      .catch(function () {});
  }

  var nativeOrdersEl = document.getElementById('native-orders-' + root.dataset.sectionId);
  if (!nativeOrdersEl) {
    showError('Orders are unavailable right now. Please make sure you are logged in and try again.');
    return;
  }

  var orders;
  try {
    orders = JSON.parse(nativeOrdersEl.textContent);
  } catch (e) {
    showError('Could not load your orders right now. Please refresh the page and try again.');
    return;
  }

  renderOrders(orders);
  fetchDeliveryStatuses(orders);
})();
